import React from 'react';
import {
  AdFormat,
  AdPlacement,
  IAdContainerWithVisibilityProps,
} from 'src/components/ads/types';
import * as S from '../styles';

const advertSpacing = { top: '10px', bottom: '10px' };

const ADS_INDEXES = [
  4,
  10,
  16,
  // Ad every 10th price row
  ...Array(16)
    .fill(10)
    .map((v, i) => v + v * i + 16),
];

const getMobileAd = (index: number) => {
  const placementNumber = Math.min(3, index + 1);

  const triggerPointProp = placementNumber > 1 ? { triggerPoint: 100 } : {};

  return (
    <S.AdvertTableRowElement key={`mobile-ad-container-${index}`}>
      <S.AdContainer
        placement={`dubbelpanorama${placementNumber}` as AdPlacement}
        format={`panorama_${placementNumber}` as AdFormat}
        min={0}
        max={860}
        spacing={advertSpacing}
        async={index > 1}
        {...triggerPointProp}
      />
    </S.AdvertTableRowElement>
  );
};

const desktopAds: IAdContainerWithVisibilityProps[] = [
  { placement: 'panorama_extra', format: 'panorama_1_wde' },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
];

const getDesktopAd = (index: number) => {
  const adProps = desktopAds[Math.min(desktopAds.length - 1, index)];
  return (
    <S.AdvertTableRowElement
      withPosition
      key={`desktop-ad-container-${index}`}
      className="pj-ui-pricelist--advert"
    >
      <S.AdContainer
        min={860}
        max={10000}
        scalable
        scaleBase=".pj-ui-pricelist--advert"
        spacing={advertSpacing}
        async={index > 1}
        {...adProps}
      />
    </S.AdvertTableRowElement>
  );
};

export const insertTableAds = (
  tableRows: JSX.Element[],
  isExperiment: boolean
) => {
  const EXPERIMENT_START_INDEX = 2;
  const indexes = isExperiment
    ? [EXPERIMENT_START_INDEX, ...ADS_INDEXES.slice(1)]
    : ADS_INDEXES;
  const adjustedAdsIndexes = indexes.filter(index => index <= tableRows.length);
  let tableRowWithAds: JSX.Element[] = tableRows;
  if (!adjustedAdsIndexes.length) {
    // special case for short list
    tableRowWithAds = injectAd(
      tableRowWithAds,
      tableRows.length,
      getDesktopAd(0)
    );
    tableRowWithAds = injectAd(
      tableRowWithAds,
      tableRows.length,
      getMobileAd(0)
    );
    return tableRowWithAds;
  }
  for (let i = adjustedAdsIndexes.length - 1; i >= 0; i -= 1) {
    const index = adjustedAdsIndexes[i];
    // Only 3 ads in desktop viewport
    if (i <= 2) {
      tableRowWithAds = injectAd(tableRowWithAds, index, getDesktopAd(i));
    }
    tableRowWithAds = injectAd(tableRowWithAds, index, getMobileAd(i));
  }

  return tableRowWithAds;
};

const injectAd = (
  tableRows: JSX.Element[],
  index: number,
  element: JSX.Element
): JSX.Element[] => {
  return tableRows
    .slice(0, index)
    .concat(element)
    .concat(tableRows.slice(index));
};
